<template>
  <v-dialog
      :value="open"
      width="480"
  >
    <v-card>
      <v-card-title/>
      <v-card-text>
        <slot/>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <TextButton @click="onClick">OK</TextButton>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import TextButton from "@/components/atoms/TextButton";
export default {
  name: "MessageDialog",
  components: {TextButton},
  props: {
    open: {
      type: Boolean
    }
  },
  methods: {
    onClick() {
      this.$emit("ok")
    }
  }
}
</script>

<style scoped>

</style>